import React from 'react';
import Link from '@/components/atoms/link';
import Typography from '@/components/atoms/typography';
import { Reference } from '@/types/lib/reference';

export interface FooterLink {
  name: string;
  href?: string;
  reference: Reference;
}

export interface Props {
  header: string;
  link: FooterLink[];
  openInNewTab?: boolean;
  className?: string;
  textSize?: number;
}

const Column: React.FC<Props> = ({ header, link, openInNewTab, className,textSize }) => {

  const hasMultiLevelChildLinks = link?.length > 1;
  const linkUrl = link?.[0]?.href ?? "#";



  return (
    <div className={className}>
      {header && (
        <Link variant="primary" link={linkUrl} target={openInNewTab ? '_blank' : ''}>
          <Typography className={`marign-bottom-0 self-start ${textSize ? `text-[${textSize}px]` : "text-[16px]"} font-medium text-neutral-200`}>
            {header}
          </Typography>
        </Link>
      )}

      {/* {hasMultiLevelChildLinks && (
        <ul role="list" className=" marign-bottom-0 flex flex-col items-start gap-y-18 self-start">
          {link.map((item, i) => (
            <li key={i}>
              <Link variant="primary" link={item.reference}>
                <Typography as="fragment">{item.name}</Typography>
              </Link>
            </li>
          ))}
        </ul>
      )} */}
    </div>
  );
};

export default Column;
